import SDKConnector from '../SDKConnector';
import { ALLOWED_SERVICES, HTTP_METHODS, SORT, SORT_BY } from '../common/types';
import log from '../Logger';
import { serviceErrorCodeHandler } from '../common/Utils';
import { APPLICATION_JSON, CALL_HISTORY_FILE, CONTENT_TYPE, FROM_DATE, HISTORY, LIMIT, NUMBER_OF_DAYS, UPDATE_MISSED_CALLS_ENDPOINT, SET_READ_STATE_SUCCESS_MESSAGE, } from './constants';
import { STATUS_CODE, SUCCESS_MESSAGE, USER_SESSIONS } from '../common/constants';
import { COMMON_EVENT_KEYS, MOBIUS_EVENT_KEYS, } from '../Events/types';
import { Eventing } from '../Events/impl';
export class CallHistory extends Eventing {
    sdkConnector;
    webex;
    janusUrl = '';
    fromDate = '';
    loggerContext = {
        file: CALL_HISTORY_FILE,
        method: 'getCallHistoryData',
    };
    userSessions;
    constructor(webex, logger) {
        super();
        this.sdkConnector = SDKConnector;
        if (!this.sdkConnector.getWebex()) {
            SDKConnector.setWebex(webex);
        }
        this.webex = this.sdkConnector.getWebex();
        this.janusUrl = this.webex.internal.services._serviceUrls.janus;
        this.registerSessionsListener();
        log.setLogger(logger.level, CALL_HISTORY_FILE);
    }
    async getCallHistoryData(days = NUMBER_OF_DAYS, limit = LIMIT, sort = SORT.DEFAULT, sortBy = SORT_BY.DEFAULT) {
        const date = new Date();
        date.setDate(date.getDate() - days);
        this.fromDate = date.toISOString();
        const sortByParam = Object.values(SORT_BY).includes(sortBy) ? sortBy : SORT_BY.DEFAULT;
        const sortParam = Object.values(SORT).includes(sort) ? sort : SORT.DEFAULT;
        log.log(`Janus API URL ${this.janusUrl}`, this.loggerContext);
        log.info(`Call history from date : ${this.fromDate}`, this.loggerContext);
        log.info(`Call history sort type : ${sortParam}`, this.loggerContext);
        log.info(`Call history sortby type : ${sortByParam}`, this.loggerContext);
        const url = `${this.janusUrl}/${HISTORY}/${USER_SESSIONS}${FROM_DATE}=${this.fromDate}&limit=${limit}&includeNewSessionTypes=true&sort=${sortParam}`;
        try {
            const janusResponse = await this.webex.request({
                uri: `${url}`,
                method: HTTP_METHODS.GET,
                service: ALLOWED_SERVICES.JANUS,
            });
            this.userSessions = janusResponse.body;
            if (sortByParam === SORT_BY.START_TIME) {
                if (sortParam === SORT.DESC) {
                    this.userSessions[USER_SESSIONS].sort((element, compareElement) => new Date(compareElement[sortByParam]).getTime() -
                        new Date(element[sortByParam]).getTime());
                }
                else if (sortParam === SORT.ASC) {
                    this.userSessions[USER_SESSIONS].sort((element, compareElement) => new Date(element[sortByParam]).getTime() -
                        new Date(compareElement[sortByParam]).getTime());
                }
            }
            const responseDetails = {
                statusCode: this.userSessions[STATUS_CODE],
                data: {
                    userSessions: this.userSessions[USER_SESSIONS],
                },
                message: SUCCESS_MESSAGE,
            };
            return responseDetails;
        }
        catch (err) {
            const errorInfo = err;
            const errorStatus = serviceErrorCodeHandler(errorInfo, this.loggerContext);
            return errorStatus;
        }
    }
    async updateMissedCalls(endTimeSessionIds) {
        const loggerContext = {
            file: CALL_HISTORY_FILE,
            method: 'updateMissedCalls',
        };
        const santizedSessionIds = endTimeSessionIds.map((session) => ({
            ...session,
            endTime: new Date(session.endTime).getTime(),
        }));
        const requestBody = {
            endTimeSessionIds: santizedSessionIds,
        };
        try {
            const updateMissedCallContentUrl = `${this.janusUrl}/${HISTORY}/${USER_SESSIONS}/${UPDATE_MISSED_CALLS_ENDPOINT}`;
            const response = await fetch(updateMissedCallContentUrl, {
                method: HTTP_METHODS.POST,
                headers: {
                    [CONTENT_TYPE]: APPLICATION_JSON,
                    Authorization: await this.webex.credentials.getUserToken(),
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                throw new Error(`${response.status}`);
            }
            const data = await response.json();
            log.info(`Missed calls are succesfully read by the user`, loggerContext);
            const responseDetails = {
                statusCode: data.statusCode,
                data: {
                    readStatusMessage: SET_READ_STATE_SUCCESS_MESSAGE,
                },
                message: SUCCESS_MESSAGE,
            };
            return responseDetails;
        }
        catch (err) {
            const errorInfo = {
                statusCode: err instanceof Error ? Number(err.message) : '',
            };
            const errorStatus = serviceErrorCodeHandler(errorInfo, loggerContext);
            return errorStatus;
        }
    }
    handleSessionEvents = async (event) => {
        if (event && event.data.userSessions.userSessions) {
            this.emit(COMMON_EVENT_KEYS.CALL_HISTORY_USER_SESSION_INFO, event);
        }
    };
    handleUserReadSessionEvents = async (event) => {
        if (event && event.data.userReadSessions.userReadSessions) {
            this.emit(COMMON_EVENT_KEYS.CALL_HISTORY_USER_VIEWED_SESSIONS, event);
        }
    };
    registerSessionsListener() {
        this.sdkConnector.registerListener(MOBIUS_EVENT_KEYS.CALL_SESSION_EVENT_INCLUSIVE, this.handleSessionEvents);
        this.sdkConnector.registerListener(MOBIUS_EVENT_KEYS.CALL_SESSION_EVENT_LEGACY, this.handleSessionEvents);
        this.sdkConnector.registerListener(MOBIUS_EVENT_KEYS.CALL_SESSION_EVENT_VIEWED, this.handleUserReadSessionEvents);
    }
}
export const createCallHistoryClient = (webex, logger) => new CallHistory(webex, logger);
